module.exports = __webpack_public_path__ + "images/vimeo.0a1dfd4f96cbd5f6456ced7eda69fa35.svg";